import {createContext, useContext, useEffect, useMemo, useReducer} from "react";
import PropTypes from "prop-types";

const RayzayUI = createContext(null);
RayzayUI.displayName = "RayzayUIContext";

function reducer(state, action) {
  switch (action.type) {
    case "MINI_SIDENAV": {
      return {...state, miniSidenav: action.value};
    }
    case "TRANSPARENT_SIDENAV": {
      return {...state, transparentSidenav: action.value};
    }
    case "SIDENAV_COLOR": {
      return {...state, sidenavColor: action.value};
    }
    case "TRANSPARENT_NAVBAR": {
      return {...state, transparentNavbar: action.value};
    }
    case "FIXED_NAVBAR": {
      return {...state, fixedNavbar: action.value};
    }
    case "OPEN_CONFIGURATOR": {
      return {...state, openConfigurator: action.value};
    }
    case "DIRECTION": {
      return {...state, direction: action.value};
    }
    case "LAYOUT": {
      return {...state, layout: action.value};
    }
    case "SET_AUTHENTICATION": {
      return {...state, isAuthenticated: action.value};
    }
      case "SET_LOGGED_IN_USER_DETAIL": {
          return {...state, loggedInUserDetail: action.value};
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function RayzayUIControllerProvider({children}) {
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUserDetail"))
  const initialState = {
    miniSidenav: false,
    transparentSidenav: true,
    sidenavColor: "primary",
    transparentNavbar: true,
    fixedNavbar: true,
    openConfigurator: false,
    direction: "ltr",
    layout: "dashboard",
    isAuthenticated: Boolean(localStorage.getItem("isAuthenticated") && (loggedInUser !== null)),
    loggedInUserDetail: loggedInUser,
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  // Persist authentication state in localStorage
  useEffect(() => {
    localStorage.setItem("isAuthenticated", controller.isAuthenticated);
    localStorage.setItem("loggedInUserDetail", JSON.stringify(controller.loggedInUserDetail));
  }, [controller.isAuthenticated, controller.loggedInUserDetail]);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);
  return <RayzayUI.Provider value={value}>{children}</RayzayUI.Provider>;
}

// Soft UI Dashboard React custom hook for using context
function useRayzayUIController() {
  const context = useContext(RayzayUI);
  if (!context) {
    throw new Error("useRayzayUIController should be used inside the RayzayUIControllerProvider.");
  }
  return context;
}

RayzayUIControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const setMiniSidenav = (dispatch, value) => dispatch({ type: "MINI_SIDENAV", value });
const setTransparentSidenav = (dispatch, value) => dispatch({ type: "TRANSPARENT_SIDENAV", value });
const setTransparentNavbar = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
const setFixedNavbar = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
const setOpenConfigurator = (dispatch, value) => dispatch({ type: "OPEN_CONFIGURATOR", value });
const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });
const setAuthentication = (dispatch, value) => dispatch({ type: "SET_AUTHENTICATION", value });
const setLoggedInUserDetail = (dispatch, value) => dispatch({type: "SET_LOGGED_IN_USER_DETAIL", value});

export {
  RayzayUIControllerProvider,
  useRayzayUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setTransparentNavbar,
  setFixedNavbar,
  setOpenConfigurator,
  setLayout,
  setAuthentication,
    setLoggedInUserDetail,
};
